
import Footer from "@/components/lyx-components/lyx-footer/index"
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import Swiper from "swiper"
import loading from '@/components/public-components/loading/index.vue'
import mapUtil from '@/javascript/mapUtil'
import EsQuery from '@/javascript/esQuery'
import util from '@/javascript/util'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
components: {
Tab,
TabItem,
loading,
goBack,
Footer
},
data () {
return {
bgImg: '',
minHeight: 0,
isShow: false,
cityData: [],
scenicsListFrom: {
pageNo: 0,
pageSize: 10
},
scenicListBar: [],
scenicList: [],
infiniteAll: false,
infiniteStatus: false,
location: {},
swiper: null,
isLoop: false,
isWeixin: util.isWeiXin()
}
},
filters: {
showLevel (key) {
const level = {
'102001': '',
'102002': '1A',
'102003': '2A',
'102004': '3A',
'102005': '4A',
'102006': '5A'
}
return level[key + '']
}
},
mounted () {
this.minHeight = document.documentElement.clientHeight;
document.title = this.PAGE_TITLE + "景区";























this.initBar();
this.getScenicList()
},
methods: {
initBar () {
const _this = this
const querystring = require('querystring')
const recommendEsQuery = new EsQuery()
recommendEsQuery.addString("category", this.XXCJ_TYPE_CODE.JQ, recommendEsQuery.and, false)
.addSort("weight", recommendEsQuery.desc, false)
.addSort("level", recommendEsQuery.desc, false)
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)
.addString('tags', '推荐', recommendEsQuery.and, false)
.addString("publishStatus", 1, recommendEsQuery.asc, false)
.addPage(0,100)
const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.INDEX_NAME_TYPE.scenic,
'esJsonQuery': recommendEsJsonQuery
})).then((response) => {




_this.$set(_this, "scenicListBar", response.data.data.map((scenic) => {
scenic._source.level = (scenic._source.level) ? parseInt(scenic._source.level) : scenic._source.level
scenic._source.areaName = scenic._source.regionFullName.split(",");

this.namelength = scenic._source.areaName.length
scenic._source.images[0].map(img => {
if (img.fileIdentify.indexOf("titleImage") != -1) {
scenic._source.titleImage = img.fileUrl
}
})

return scenic._source
})
);

if (this.scenicListBar.length > 1) {
this.isLoop = true;
} else {
_this.bgImg = _this.scenicListBar[0].titleImage;
}
_this.bgImg = _this.scenicListBar[0].titleImage;
this.$nextTick(() => {
new Swiper(".scenic-swiper", {
slidesPerView: "auto",
centeredSlides: !this.isLoop,
spaceBetween: 20,
loop: false,
onSlideChangeEnd: function (swiper) {
_this.bgImg = _this.scenicListBar[swiper.activeIndex % _this.scenicListBar.length].titleImage;
}
})
})
})
},
balck () {
this.$router.go(-1)
},

locationResult (val) {
this.location = val
this.initBar()
this.getScenicList()
},
onItemClick ({ cityId }) {
this.scenicsListFrom.pageNo = 0
this.infiniteAll = false
this.infiniteStatus = true
this.scenicList = []
this.$router.replace('/scenicList/' + cityId)
this.getScenicList()
},

getScenicList: function () {
const querystring = require('querystring')
const recommendEsQuery = new EsQuery()
recommendEsQuery.addString("category", this.XXCJ_TYPE_CODE.JQ, recommendEsQuery.and, false)
.addSort("level", recommendEsQuery.desc, false)
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)
.addPage(this.scenicsListFrom.pageNo * this.scenicsListFrom.pageSize, this.scenicsListFrom.pageSize)
.addString("publishStatus", 1, recommendEsQuery.asc, false)
const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.INDEX_NAME_TYPE.scenic,
'esJsonQuery': recommendEsJsonQuery
})).then((response) => {
window.addEventListener('scroll', this.windowScroll) 
const scenics = response.data.data,
scenicList = scenics.map(scenic => {
scenic._source.level = (scenic._source.level) ? parseInt(scenic._source.level) : scenic._source.level
scenic._source.areaName = scenic._source.regionFullName.split(",");



this.namelength = scenic._source.areaName.length
scenic._source.images[0].map(img => {

if (img.fileIdentify.indexOf("titleImage") != -1) {
scenic._source.titleImage = img.fileUrl
}
})
return scenic._source
})
this.scenicList = this.scenicList.concat(scenicList)
if (response.data.data.length < this.scenicsListFrom.pageSize) {
this.infiniteAll = true
}
this.infiniteStatus = false
})
},
windowScroll (e) {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
if (scrollTop > 0) {
this.isShow = true
} else {
this.isShow = false
}

if (util.pullUpLoad()) {
this.infinite()
}
},
infinite () {
if (this.infiniteAll) {
return
}
if (this.infiniteStatus) {
return
}
this.scenicsListFrom.pageNo += 1
this.infiniteStatus = true
this.getScenicList()
}
}
}
